import {
  base_colorContentBorder,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.ManageSubscriptionHeader {
    display: flex;
    justify-content: space-between;
    gap: ${spacing(12)};
    width: 100%;

    & > * {
      flex-basis: 50%;
      height: fit-content;
    }

    .plan-subheader {
      ${font_md};
      color: ${text_colorTextSecondary};
    }

    .title {
      font-size: 48px;
      line-height: 48px;
      font-family: ${font_family_weight_medium};
    }

    .divider {
      border-bottom: 1px solid ${base_colorContentBorder};
    }

    .details-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: ${spacing(3)} 0;
    }

    .upgrade-button {
      width: 150px;
    }
  }
`
